(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magstor-thunderbolt"] && !Shopify.designMode) return;
  try {
    
function initMagstorThunderbolt(scope) {
  scope.querySelectorAll('[data-magstor-thunderbolt]').forEach(root => {
    if (root.dataset.filterReady) return;
    root.dataset.filterReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = root.querySelector('[data-shimmer-toggle]');
    let manuallyPaused = false;
    const states = Array.from(root.querySelectorAll('.tb-series-mark')).map(mark => ({
      mark, gradient: mark.querySelector('linearGradient'), visible: false,
      running: false, elapsed: 0, lastTime: null
    })).filter(state => state.gradient);
    let frame = null;
    const animateShimmer = timestamp => {
      frame = null;
      states.forEach(state => {
        if (!state.running) return;
        if (state.lastTime !== null) state.elapsed = (state.elapsed + timestamp - state.lastTime) % 4800;
        state.lastTime = timestamp;
        state.gradient.setAttribute('gradientTransform', `translate(${state.elapsed / 2400} 0)`);
      });
      if (states.some(state => state.running)) frame = requestAnimationFrame(animateShimmer);
    };
    const syncShimmer = () => {
      if (toggle) {
        toggle.hidden = motion.matches || states.length === 0 || !('IntersectionObserver' in window);
        toggle.textContent = manuallyPaused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel;
      }
      states.forEach(state => {
        const running = state.visible && !state.mark.closest('[data-family]').hidden &&
          !motion.matches && !manuallyPaused && !document.hidden;
        if (state.running !== running) state.lastTime = null;
        state.running = running;
      });
      if (states.some(state => state.running)) {
        if (frame === null) frame = requestAnimationFrame(animateShimmer);
      } else if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
    };
    const onToggle = () => { manuallyPaused = !manuallyPaused; syncShimmer(); };
    if (toggle) toggle.addEventListener('click', onToggle);
    if (typeof motion.addEventListener === 'function') motion.addEventListener('change', syncShimmer);
    else if (typeof motion.addListener === 'function') motion.addListener(syncShimmer);
    document.addEventListener('visibilitychange', syncShimmer);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.find(item => item.mark === entry.target);
          if (state) state.visible = entry.isIntersecting;
        });
        syncShimmer();
      }, { threshold: 0.1 });
      states.forEach(state => observer.observe(state.mark));
    }
    syncShimmer();
    const onUnload = event => {
      if (!event.target.contains(root)) return;
      if (observer) observer.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      states.forEach(state => { state.running = false; state.lastTime = null; });
      if (toggle) toggle.removeEventListener('click', onToggle);
      if (typeof motion.removeEventListener === 'function') motion.removeEventListener('change', syncShimmer);
      else if (typeof motion.removeListener === 'function') motion.removeListener(syncShimmer);
      document.removeEventListener('visibilitychange', syncShimmer);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);

    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelectorAll('[data-family]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.family !== filter; });
      syncShimmer();
    }));
  });
}
initMagstorThunderbolt(document);
document.addEventListener('shopify:section:load', event => initMagstorThunderbolt(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      const sectionId = this.id.replace('ProductModal-', '');
      const popupSlider = this.querySelector('.js-popup-slider');

      if (mediaId && popupSlider && typeof window.slidePopupToMedia === 'function') {
        window.slidePopupToMedia(popupSlider, `${sectionId}-${mediaId}`);
      }

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
